import { render, staticRenderFns } from "./verified.vue?vue&type=template&id=09714a50&scoped=true"
import script from "./verified.vue?vue&type=script&lang=js"
export * from "./verified.vue?vue&type=script&lang=js"
import style0 from "./verified.vue?vue&type=style&index=0&id=09714a50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09714a50",
  null
  
)

export default component.exports